import { defaultConfig, defineSlotRecipe } from '@chakra-ui/react';

import merge from 'lodash/merge';

export const tagSlotRecipe = defineSlotRecipe(
    merge(defaultConfig?.theme?.slotRecipes?.tag, {
        base: {
            root: {
                fontWeight: 'bold',
                borderRadius: 'sm',
            },
        },

        variants: {
            size: {
                sm: {
                    root: {
                        py: 1,
                        px: 1.5,
                    },
                    label: {
                        fontSize: 'xs',
                    },
                },
                md: {
                    root: {
                        py: 1,
                        px: 2,
                    },
                    label: {
                        fontSize: 'sm',
                    },
                },
            },
            variant: {
                outline: {
                    root: {
                        '--shadow-color': 'colors.colorPalette.500',
                    },
                },
            },
        },
    }),
);
